// Generated using typescript-generator version 2.0.400 on 2018-09-25 17:58:16.
import { 
    Account, AccountType, OptionStrategy, TradeCommission, TradingExchangeOrder,
    Quote, TradingDayInfo, TransactionType, OrderType, OrderDuration
} from '../common/trading-common.model';
import { TradingEntitlements } from '../common/trading-entitlements';

export interface OptionTradingOrder extends TradingExchangeOrder {
    underlierSymbol: string;
    optionSymbol: string;
    underlyer: string;
    expiration: Date;
    strikePrice: number;
    optionRoot: string;
    underlyingSymbolQuote: Quote;
}

export interface MultiLegOptionTradingOrder extends TradingExchangeOrder {
    strategy: OptionStrategy;
    optionLegList: OptionLeg[];
    multiLegDtlKey: string;
}

export interface OptionLeg {
    transactionType: TransactionType;
    ordQty: number;
    quote: Quote;
    commission: TradeCommission;
    accountType: AccountType;

    // For order details: Open/Close Indicator
    netxOpnClsInd: string;

    // For order details: Leaves Quantity (professional)
    strLvsQty: string;

    // For order details: Canceled Quantity (professional)
    nmeTxt2: string;

    // For order details: Execution Quantity (professional)
    nmeTxt3: string;
}

export interface OptionOrderEntryWrapper {
    platform: string;
    tradingEntitlements: TradingEntitlements;
    account: Account;
    order: OptionTradingOrder;
    isOrderSuccessfullySubmitted: boolean;
    openOrderStatus: boolean;
    origOrder: OptionTradingOrder;
    tradingDayInfo: TradingDayInfo;
    contextType: string;
    isUserFromLegacyOTS: boolean;
    transactionTypeStringForOrderReview: string;
    username?: string;
}

export interface MultiLegOptionOrderEntryWrapper {
    platform: string;
    tradingEntitlements: TradingEntitlements;
    account: Account;
    order: MultiLegOptionTradingOrder;
    isOrderSuccessfullySubmitted: boolean;
    openOrderStatus: boolean;
    origOrder: MultiLegOptionTradingOrder;
    tradingDayInfo: TradingDayInfo;
    contextType: string;
    isUserFromLegacyOTS: boolean;
    transactionTypeStringForOrderReview: string;
    isComplexPopup: boolean;
    username?: string;
}

export interface ExpiryDate {
    optUnderlyingSymId: string;
    optExpDate: string;
    optRootId: string;
    isSelected: boolean;
}

export interface StrikePrice {
    optExpDate: string;
    optStrikePrc: string;
    optRootId: string;
}

export interface OptionChainQuoteRepeated {
    blockCount: number;
    optExpDate: string;
    optStrikePrc: string;
    optRootId: string;
    optSymId: string;
    mainDeliverable: number;
    unusualOptions: string;
    sqtBidPrc: string;
    sqtAskPrc: string;
    sqtLastPrc: string;
    sqtChgPrc: string;
    eqtClsPrc: string;
    lastTrdTime: string;
    qtIntlInd: string;
    qtCurrencyCd: string;
    putCallInd: string;
    inTheMoney: boolean;
    sqtBidsize: number;
    sqtAsksize: number;
    sqtVol: number;
    sqtOpenIntrst: number;
    sqtPctPrc: string;
    eqtAnnlHiPrc: string;
    eqtAnnlLowPrc: string;
}

export interface OptionAllocationOrderWrapper {
    status: string;
    symbol: string;
    transaction: string;
    avgActType: string;
    orderQty: string;
    instruction: string;
    commAmt: string;
    commType: string;
    lmtPrice: string;
    stopLmtPrice: string;
    duration: string;
    dateTime: string;
    approvedBy: string;
    allocAccount: string;
    allocCategory: string;
    handInst: string;
    secType: string;
    tid: string;
    orderFrom: string;
    cnfmOrdFrm: string;
}

export interface MultiLegOptionTrackedCoreChanges  {
    transactionType: TransactionType[];
    ordQty?: number[];
    orderType?: OrderType;
    settlementCcy?: string;
    stopPrice?: number;
    limitPrice?: number;
    duration?: OrderDuration;
    gtdDate?: string;
    chainType?: string[];
    custOrFirmInd?: string;
    strikePrice?: string[];
    expirationDate?: string[];
    addlOrdData?: string;
    trailer?: string;
    optionSymId?: string[];
    accountType: AccountType[];
    fdid: string;
    sourceOverride?: string;
    strategy?: OptionStrategy;
}

export interface OptionsLegalEntity{
    shortName: string,
    FDID?: string,
}

export const WeeklyIndexUnderliers: {} = {
    'SPXW': 'SPX',
    'NDXP': 'NDX',
    'RUTW': 'RUT',
    'VIXW': 'VIX'
}


